import { forwardRef } from "react";
import { cn } from "@/lib/cn";
import type { SectionHeaderProps } from "./SectionHeader.types";

export const SectionHeader = forwardRef<HTMLDivElement, SectionHeaderProps>(
  ({ className, title, description, eyebrow, actions, compact, titleClassName, descriptionClassName, ...props }, ref) => (
    <div ref={ref} className={cn("bfrs-flex bfrs-min-w-0 bfrs-items-start bfrs-justify-between bfrs-gap-3", className)} {...props}>
      <div className="bfrs-min-w-0">
        {eyebrow && <div className="bfrs-mb-1 bfrs-text-[10.5px] bfrs-font-bold bfrs-uppercase bfrs-tracking-[0.08em] bfrs-text-text-muted">{eyebrow}</div>}
        <div className={cn("bfrs-font-semibold bfrs-leading-snug bfrs-text-text-primary", compact ? "bfrs-text-sm" : "bfrs-text-base", titleClassName)}>{title}</div>
        {description && <div className={cn("bfrs-mt-1 bfrs-text-sm bfrs-leading-5 bfrs-text-text-muted", compact && "bfrs-text-xs", descriptionClassName)}>{description}</div>}
      </div>
      {actions && <div className="bfrs-flex bfrs-shrink-0 bfrs-items-center bfrs-gap-2">{actions}</div>}
    </div>
  )
);

SectionHeader.displayName = "SectionHeader";
